export default __webpack_public_path__ + "static/media/nz.a9f3d8cb.svg";